<template>
  <div>
    <DataTable
        class="mt-5"
        :loading="isLoading"
        :value="currentTabState.tableData"
        :rows="currentTabState.rowsPerPage"
        :totalRecords="currentTabState.totalRecords"
        :sortField="currentTabState.sortField"
        :sortOrder="currentTabState.sortOrder"
        :rowGroupMode="rowGroupMode"
        :groupRowsBy="groupRowsBy"
        :rowClass="rowClass"
        selectionMode="single"
        @row-select="onRowSelect"
        @row-click="onRowClick"
        @page="onPageChange"
        @sort="onSort"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[1, 2, 5, 10, 20]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        :lazy="true"
        :expandedRows.sync="currentTabState.expandedRows"
    >
      <Column
          v-for="col in columns"
          :key="col.field"
          :field="col.field"
          :header="col.header"
          :sortable="col.sortable"
          :headerStyle="{ width: col.width }"
          :expander="col.expander ? true : undefined"
          :headerClass="col.headerClass"
          :styles="{ 'text-align': col.align }"
      >
        <template v-if="col.custom" #body="slotProps">
          <slot :name="col.slotName" :rowData="slotProps.data" />
        </template>
      </Column>

      <template #empty>
        No records found.
      </template>
    </DataTable>

    <Paginator
        :first.sync="currentTabState.first"
        template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        @page="onPageChange"
        :rows.sync="currentTabState.rowsPerPage"
        :totalRecords="currentTabState.totalRecords"
        :rowsPerPageOptions="[1, 2, 5, 10, 20]"
    >
    </Paginator>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    columns: {
      type: Array,
      required: true,
    },
    rowGroupMode: {
      type: String,
      default: null,
    },
    groupRowsBy: {
      type: String,
      default: null,
    },
    rowClass: {
      type: Function,
      default: null,
    },
    enableRowClick: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapState("documents", {
      currentTabState: (state) => state.tabs[state.currentTab],
      isLoading: (state) => state.isLoading,
      currentTab: (state) => state.currentTab,
    }),
  },

  methods: {
    ...mapActions("documents", ["updateTableSettings", "updateSortOptions"]),

    onRowSelect(event) {
      this.$emit("row-select", event);
    },

    onRowClick(event) {
      if (this.enableRowClick) {
        this.$emit("row-click", event);
      }
    },

    onPageChange(event) {
      this.updateTableSettings({
        rows: event.rows,
        page: event.page,
      });
    },

    onSort(event) {
      this.updateSortOptions({
        field: event.sortField,
        order: event.sortOrder,
      });
    },
  },
};
</script>
